import {JSX} from 'preact/jsx-runtime';

import {PropsWithChildren} from 'utilities/props';

interface Props {
  limit?: number;
}

export function Optional({children}: PropsWithChildren) {
  return children as JSX.Element;
}

export function CappedList({children, limit = 2}: PropsWithChildren<Props>) {
  const filteredChildren = (
    children instanceof Array ? children : [children]
  ).filter(Boolean) as JSX.Element[];

  if (filteredChildren.length > limit) {
    const elements = [];
    while (elements.length < limit && filteredChildren.length > 0) {
      const node = filteredChildren.shift() as JSX.Element;
      if (
        node.type === Optional &&
        // remove Optional until adding other elements will exceed the limit
        elements.length + filteredChildren.length + 1 > limit
      ) {
        continue;
      }
      elements.push(node);
    }
    return <>{elements}</>;
  }

  return <>{filteredChildren}</>;
}
